import * as React from 'react';
import './account/MyAccount.css';
import phoneImg from './img/telephone.svg';
import emailImg from './img/envelope.svg';
import avatar from './img/avatar.svg';
import idCard from './img/id-card.svg';

interface Props {
    name: string;
    email: string;
    phone?: string;
    customerNumber?: string;
}

class UserContactDetails extends React.PureComponent<Props> {
    public render(): JSX.Element {
        return (
            <div className="contact-details">
                <span>
                    <img src={avatar} />
                    {this.props.name}
                </span>
                <span>
                    <img src={emailImg} />
                    {this.props.email}
                </span>
                {this.props.phone && (
                    <span>
                        <img src={phoneImg} />
                        {this.props.phone}
                    </span>
                )}
                {this.props.customerNumber && (
                    <span>
                        <img src={idCard} />
                        {this.props.customerNumber}
                    </span>
                )}
            </div>
        );
    }
}

export default UserContactDetails;



// WEBPACK FOOTER //
// ./src/view/UserContactDetails.tsx